<template>
<v-container class="pt-0 px-0" fluid>
  <template v-if="!displayRouterContent">
    <v-tabs v-model="displayedTab" background-color="integrity" dark show-arrows icons-and-text @change="tabChange">
      <v-tab v-for="(config, i) in tabConfig" :key="i">
        {{ config.title }}
        <v-icon v-if="config.icon">{{ config.icon }}</v-icon>
        <v-img v-if="config.img"
          :class="{ notSelected: displayedTab !== i }"
          :src="config.img"
          max-height="24"
          max-width="24" />
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="displayedTab">
      <v-tab-item v-for="(config, i) in tabConfig" :key="i">
        <v-container fluid>
          <v-row wrap>
            <v-col cols="12" class="pt-0">
              <component :is="config.component" :client="client" @force-tab-change="handleForceTabChange" />
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
  </template>
  <template v-else>
    <router-view />
  </template>
</v-container>

</template>

<style>
/* .v-slide-group__prev{
  display: none !important
} */

.notSelected {
  filter: opacity(60%);
  -webkit-filter: opacity(60%);
}
</style>

<script>
import analyticsService from '@/services/shared/analyticsService.js';
import { mapState, mapActions } from 'vuex';

import GeneralInfo from '@/components/Client/GeneralInfo.vue';
import ProfilesWrapper from '@/components/Client/Profiles/ProfilesWrapper';
import ClientContacts from '@/components/Client/ClientContacts';
import Policies from '@/components/Client/Policies/Policies.vue';

export default {
  components: {
    GeneralInfo,
    ProfilesWrapper,
    ClientContacts,
    Policies
  },
  data: function () {
    return {
      clientTypes: {
        0: 'None',
        65: 'AgentOrEmployee',
        67: 'Customer',
        69: 'PersonalContact',
        71: 'AgencyContact',
        73: 'Carrier',
        77: 'EmergencyContact',
        79: 'Other',
        86: 'Vendor'
      },
      tabConfig: [
        {
          title: 'Info',
          icon: 'mdi-information-outline',
          component: 'GeneralInfo',
          gtagConfig: { action: 'Tab Navigation', category: 'Client', label: 'Client Info Tab' }
        },
        {
          title: 'Contact Info',
          img: require('@/assets/contacts_icon.png'),
          component: 'ClientContacts',
          gtagConfig: { action: 'Tab Navigation', category: 'Client', label: 'Contact Info Tab' }
        },
        {
          title: 'People',
          icon: 'mdi-account-group',
          component: 'ProfilesWrapper',
          gtagConfig: { action: 'Tab Navigation', category: 'Client', label: 'People Tab' }
        },
        {
          title: 'Policies',
          icon: 'mdi-file-document',
          component: 'Policies',
          gtagConfig: { action: 'Tab Navigation', category: 'Client', label: 'Policies Tab' }
        }
      ]
    };
  },
  computed: {
    ...mapState(['client', 'activeClientTab']),
    displayedTab: {
      get: function () {
        return this.activeClientTab;
      },
      set: function (val) {
        this.setActiveClientTab(val);
      }
    },
    clientId: function () {
      return this.$route.params.clientId;
    },
    clientIdDisplay: function () {
      return this.clientId.padStart(8, 0);
    },
    clientStatus: function () {
      if ((this.client || null) === null) return 'Unknown Client Status';
      if (this.client.isActive) return 'Active';
      if (this.client.isProspect) return 'Prospect';
      if (this.client.isLead) return 'Lead';
      if (this.client.isDeadFile) return 'Dead File';

      return 'Unknown Client Status';
    },
    clientType: function () {
      if ((this.client || null) === null) return 'Unknown Client Type';
      return this.clientTypes[this.client.clientType];
    },
    customerType: function () {
      if ((this.client || null) === null) return 'Unknown Customer Type';
      var types = [];
      if (this.client.isPersonal) types.push('Personal');
      if (this.client.isCommercial) types.push('Commercial');
      if (this.client.isLifeHealth) types.push('Life/Health');
      if (this.client.allowCrossSell) types.push('Allow Cross Selling');
      if (this.client.doNotMarket) types.push('Do Not Market');

      return types.join(', ');
    },
    displayRouterContent: function () {
      return ['clientPolicyDetail', 'policyVehicle', 'policyDriver', 'lobLanding', 'vehicle', 'driver'].includes(this.$route.name);
    }
  },
  methods: {
    ...mapActions(['setActiveClientTab']),
    tabChange: function (value) {
      var tab = this.tabConfig[value];
      if ((tab || null) !== null) {
        analyticsService.sendEvent(this.$gtag, tab.gtagConfig.action, tab.gtagConfig.category, tab.gtagConfig.label);
      }
    },
    handleForceTabChange: function (index) {
      this.setActiveClientTab(index);
      this.tabChange(index);
    }
  }
};
</script>
